import styled from 'styled-components';
import { Modal } from 'antd';

export const LoginStyle = styled.div`
  position: relative;
  .tablet-type-login {
    z-index: 100;
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: #F7F8FA;
    .logo {
      position: absolute;
      width: 140px;
      left: 50%;
      top: 15%;
      transform: translateX(-50%);
    }
  }
  .top-bar {
    height: 64px;
    background: #ffffff;
    padding-left: 8%;
    padding-right: 8%;
    display: flex;
    align-items: center;
    .logo {
      width: 106px;
      height: 26px;
      flex-shrink: 0;
    }
    .tab {
      flex-grow: 2;
      padding: 0 80px;
      display: flex;
      .tab-item {
        user-select: none;
        cursor: pointer;
        position: relative;
        font-size: 16px;
        color: #333333;
        padding: 0 20px;
        &.active {
          font-weight: 500;
          &::after {
            content: '';
            position: absolute;
            bottom: -4px;
            left: 50%;
            transform: translateX(-50%);
            width: 10px;
            height: 2px;
            border-radius: 2px;
            background: #0077ff;
          }
        }
      }
    }
    .follow {
      flex-shrink: 0;
      font-size: 16px;
      color: #333333;
      cursor: pointer;
    }
  }
  .login-outer {
    background: #f0f4fa;
  }
  .login-container {
    position: relative;
    text-align: center;
    max-width: 1920px;
    min-width: 1200px;
    margin: 0 auto;
    .login-text {
      position: absolute;
      top: 50%;
      left: 8vw;
      transform: translateY(-50%);
      .login-title {
        font-size: 36px;
        font-weight: 500;
        color: #333333;
      }
      .login-subtitle {
        margin-top: 26px;
        font-size: 18px;
        color: #333333;
        text-align: left;
      }
    }
    .back-img {
      height: 600px;
    }
  }
  .advantage-img {
    position: absolute;
    top: 624px;
    left: 50%;
    transform: translateX(-50%);
    display: block;
    width: 1200px;
    height: 104px;
  }
  .middle-img {
    display: block;
    width: 100vw;
  }
  .bottom-img {
    position: relative;
    .bottom-login-btn {
      font-size: 16px;
      position: absolute;
      bottom: 16%;
      left: 50%;
      transform: translateX(-50%);
      border: 1px solid #0077ff;
      border-radius: 4px;
      padding: 8px 18px;
      color: #0077ff;
      cursor: pointer;
      opacity: 0;
    }
  }
  .hidden {
    display: none;
  }
`;

export const ModalStyle = styled(Modal)`
  .ant-modal-body {
    width: 350px;
    height: 400px;
    padding: 0px;
    border-radius: 4px;
    position: relative;
  }
`;
